import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  strip(event) {
    event.target.value = event.target.value.trim();
  }
}
